module.exports = __webpack_public_path__ + "static/img/zhongtai.f1db65cd.png";